const config = {
   // BASE_URL: "http://localhost:5000",
   BASE_URL: "https://pawning.nmdskandy.lk"
   // BASE_URL: "https://pawningcenter-b-production.up.railway.app",
   // BASE_URL: ["http://localhost:5000","https://pawningcenter-b-production.up.railway.app"],
};

export default config;